export const DrawingMode = {
    NONE: 'none',
    DRAW: 'draw',
    UNIT: 'unit',
    DOOR: 'door',
    CALIBRATION: 'calibration',
    INTERNAL_WALL: 'internal_wall',
};
export const ViewerMode = {
    NONE: 'none',
    VIEW: 'view',
    ANNOTATE: 'annotate',
    MATRIX: 'matrix',
};

export const ClosetMode = {
    EDIT: 'edit',
    DELETE: 'delete',
    OBSTACLE: 'obstacle',
    NONE: 'none',
};

export const DoorType = {
    SINGLE: 'SINGLE',
    DOUBLE: 'DOUBLE',
    PATIO: 'PATIO',
    DOORWAY: 'DOORWAY',
};

export const OpeningType = {
    INSIDE: 'INSIDE',
    OUTSIDE: 'OUTSIDE',
};

export const AttachmentType = {
    DOOR: 'DOOR',
    WINDOW: 'WINDOW',
};

export const ObstacleType = {
    RECTANGLE: 'rectangle',
    CIRCLE: 'circle',
};

export const PageTypes = {
    WorkSpace: 'workSpace',
    HomePage: 'homePage',
};

export const ProjectScope = {
    ALL_CLOSETS: 'All Closets',
    BEDROOM: 'Bedroom',
    CLOSET: 'Closet',
    CUSTOM: 'Custom',
};

export const ClosetColor = {
    WHITE: 'White',
    GREY: 'Grey',
    OAK: 'Oak',
};

export const HandleColor = {
    BLACK: 'Black',
    CHROME: 'Chrome',
    BRASS: 'Brass',
    NICKEL: 'Nickel',
};

export const HandleStyle = {
    T_BAR: 'T_Bar',
    KNOB: 'Knob',
};

export const RodColor = {
    BLACK: 'Black',
    CHROME: 'Chrome',
    BRASS: 'Brass',
    NICKEL: 'Nickel',
};

export const DrawerColor = {
    WHITE: 'White',
    GREY: 'Grey',
    OAK: 'Oak',
};

export const DoorStyle = {
    SLAB: 'Slab',
    SHAKER: 'Shaker',
};

export const DoorColor = {
    WHITE: 'White',
    GREY: 'Grey',
    OAK: 'Oak',
};

export const Color = {
    White: 1,
    Grey: 2,
    Oak: 3,
};

export const ButtonMode = {
    Unit: 'unit',
    Closet: 'closet',
    Door: 'door',
};

export const DoorSwing = {
    NONE: 'NONE',
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
};
